// Note! This exists in a separate file because @avensia/excite-frontdoor also depends on it
export interface Breakpoints {
  [key: string]: number;
}

export let breakpoints: Breakpoints;
export let breakpointsSortedByWidth: [string, number][] = [];
export function registerBreakpoints(points: Breakpoints) {
  breakpoints = points;
  breakpointsSortedByWidth = Object.entries(points).sort((a, b) => a[1] - b[1]);
}

export function getBreakpointByWidth(width: number) {
  for (const [key, breakpointWidth] of breakpointsSortedByWidth) {
    if (width <= breakpointWidth) {
      return key;
    }
  }
  // If no breakpoint is found, return the last one (largest width)
  return breakpointsSortedByWidth[breakpointsSortedByWidth.length - 1][0];
}
